/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/study-treatment-arm.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getProcessedFieldChangeItems, getFieldChangeItems } from 'views/pages/admin/audit-log/service';

const StudyTreatmentArmRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = oldRecord
        ? {
              ...oldRecord,
              CfId: oldRecord.CfId?.$oid,
          }
        : null;
    const refactoredNewRecord = newRecord
        ? {
              ...newRecord,
              CfId: newRecord.CfId?.$oid,
          }
        : null;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({ oldRecord, newRecord, oldItem, newItem, field }),
    );

    return <FieldChangeGrid items={items} />;
};

export { StudyTreatmentArmRecordChangeGrid };
